export default __webpack_public_path__ + "static/bny_full-6a6150e729e88c80ed552f14258a3b56.png";